/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import React, {useState} from 'react';
import {Platform, View} from 'react-native';
import {connect} from 'react-redux';

import {getNextDay, handleDateValue} from '../../../../common/utils/date';

import {getTypeContratPayment} from '../../../../common/utils/paiement';
import {Validation} from '../../../../common/utils/paiement/validationVisa';
import {separateurMillier} from '../../../../common/utils/rendering';
import config from '../../../../data/config';
import {MIN_COTISATION} from '../../../../data/constants/Assurance/assuranceRetraite';
import {
  defaultVisaErrorValues,
  LOADING_MESSAGE,
  redirectRoutesAfterPayment,
  showErrorValuesDefault,
  showErrorValuesSubmit,
} from '../../../../data/constants/paiement';
import {
  formatDataForRapatriementRenewal,
  sendInfo,
} from '../../../../data/factory/paiement';
import {IVisa, IVisaError} from '../../../../data/types/interface/paiement';
import {StackParams} from '../../../../data/types/navigation';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {postFormData} from '../../../../services/technique/api';
import SubmitButtons from '../../../components/Button/SecondaryButton';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {InputDatePicker} from '../../../components/Inputs/InputDatePicker';
import {InputField} from '../../../components/Inputs/InputField';
import Label from '../../../components/Label';
import LoaderWithMessage from '../../../components/LoaderWithMessage';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../../components/PageContainer';

type NavigationProps = StackNavigationProp<StackParams, 'TelmaPayment'>;

export const CbPaymentForm = (props: any) => {
  const {user, cbTransactionUser} = props;
  const {contratEC = {}} = props?.user || {};
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const primTTC = contratEC.primeTTC || contratEC.montant || 0;
  const premierVersement = contratEC.premierVersement
    ? contratEC.premierVersement
    : 0;
  const [transactionId, setTransactionId] = useState<string>('');

  const nextDay: Date = React.useMemo(() => {
    return (
      dayjs(contratEC.dateEffet).toDate() ||
      dayjs(contratEC.dateDebut).toDate() ||
      getNextDay(new Date(handleDateValue(contratEC.dateEcheance)))
    );
  }, [contratEC]);

  const [values, setValues] = React.useState<IVisa>({
    montant:
      contratEC.typeContrat === undefined &&
      contratEC.typePayment !== 'prime' &&
      contratEC.typePayment !== 'renouvellement'
        ? 0
        : contratEC.typeContrat === 'retraite'
        ? premierVersement
        : primTTC,
    motif: '',
    typeContrat: contratEC.typeContrat === 'voyage' ? 'voyage' : 'retraite',
    simulationId: contratEC.simulationId,
    numeroPolice: contratEC.numeroPolice,
    dateEffet: nextDay.toString() || '',
  });
  const [error, setError] = React.useState<IVisaError>(defaultVisaErrorValues);
  const [showErrors, setShowErrors] = useState(showErrorValuesDefault);
  const [IsLoading, setIsLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loaderMessage, setLoaderMessage] = useState(LOADING_MESSAGE);

  const handleCancel = () => {
    goBack();
  };
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoMessage] = useState('');

  const toFormData = (data: any) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      if (key !== 'motif') {
        formData.append(key, data[key]);
      }
    });
    return formData;
  };

  const postPayment = (data: any) => {
    if (data.data) {
      const formData = toFormData(data.data);
      setLoaderMessage(LOADING_MESSAGE);

      if (Platform.OS !== 'web') {
        postFormData(null, formData, data.paiementUrl, {
          'Content-Type': 'multipart/form-data',
        })
          .then((res: any) => {
            console.log('res post paie', res.config);
            setIsLoading(false);
            navigate('PaymentWebView', {
              url: Platform.OS === 'ios' ? res.config.url : data.paiementUrl,
              session: Platform.OS === 'ios' ? res.data : data,
              titleHeader: 'Paiement par carte bancaire',
            });
          })
          .catch(error => {
            console.error(error);

            setIsLoading(false);
          });
      } else {
        postFormData(
          null,
          formData,
          data.paiementUrl,
          {
            'Content-Type': 'multipart/form-data',
          },
          true,
        )
          .then(() => {
            const newWindow = window.open(
              data.paiementUrl,
              '_blank',
              'width=800,height=600',
            );
            window.onmessage = (message: any) => {
              if (message.data === 'close') {
                newWindow?.close();
              }
            };
            newWindow?.focus();
          })
          .catch(error => {
            console.error(error);
          });
      }
    }
  };

  const sendPayment = () => {
    const contrat = user?.contratEC?.typeContrat;
    if (
      contrat === 'retraite' ||
      (contratEC.typeContratPayment === 'retraite' &&
        (contratEC.primeTTC === '' || contratEC.typeContrat === undefined))
    ) {
      values.typeContrat = 'retraite';
      values.simulationId = contratEC.simulationId;
    } else {
      values.typeContrat = getTypeContratPayment(
        contrat,
        contratEC?.typeContratPayment,
      );
    }

    const extraInformation =
      values.typeContrat == 'rapatriement'
        ? formatDataForRapatriementRenewal(contratEC)
        : {};

    setIsLoading(true);

    cbTransactionUser(
      {
        ...values,
        montant: parseInt(`${values.montant}`.split(' ').join(''), 10),
        typePayment: contratEC.typePayment ?? '',
        dateEffet: values.dateEffet
          ? dayjs(values.dateEffet).isValid()
            ? dayjs(values.dateEffet).format('DD/MM/YYYY')
            : values.dateEffet
          : dayjs().format('DD/MM/YYYY'),
        numeroPolice:
          contratEC.typePayment == 'renouvellement'
            ? props.user.numeroPolice
            : contratEC.numeroPolice,
        ...extraInformation,
      },
      (res: any) => {
        console.log(res);

        if (res) {
          if (res?.cbTransactionResponse?.data?.transactionId) {
            setTransactionId(res?.cbTransactionResponse?.data?.transactionId);
            postPayment(res.cbTransactionResponse.data);
          } else {
            setErrorMessage('Erreur sur le paiement');
            setShowErrorModal(true);
          }
        } else {
          setErrorMessage('Erreur sur le paiement');
          setShowErrorModal(true);
        }
        setIsLoading(false);
      },
    );
  };
  const showErrorMessage = (message: string) => {
    setErrorMessage(message);
    setShowErrorModal(true);
  };

  const handleSubmit = () => {
    setShowErrors(showErrorValuesSubmit);
    setIsLoading(true);
    setError(Validation(contratEC, values));
    if (noError(Validation(contratEC, values))) {
      sendPayment();
    } else {
      setIsLoading(false);
    }
  };
  const redirectToHome = (paramsSend: any) => {
    setIsLoading(false);
    const route = redirectRoutesAfterPayment[paramsSend.title];

    if (route) {
      navigate(route, {id: paramsSend.id});
    } else if (paramsSend.numeroPolice) {
      navigate('DetailContrat', paramsSend);
    } else {
      navigate('Home');
    }
  };

  const infoOkCompletion = () => {
    setShowInfoModal(false);
    setIsLoading(true);
    setLoaderMessage(' ');
    sendInfo({
      ...props,
      user: {
        ...props.user,
        contratEC: {
          ...props.user.contratEC,
          dateEffet: values.dateEffet,
          transactionId,
        },
      },
      okCompletion: redirectToHome,
      showError: showErrorMessage,
      setIsLoading: () => {
        setIsLoading(false);
      },
    });
  };

  const noError = (validate: any) => {
    let bNoError = true;
    Object.values(validate).forEach(element => {
      if (element !== '') {
        bNoError = false;
      }
    });
    return bNoError;
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleChange = (name: string, value: any, fired: boolean) => {
    setShowErrors(prevShowErrors => ({
      ...prevShowErrors,
      montant: false,
      motif: false,
      typeContrat: false,
    }));
    setValues((prevValues: IVisa) => ({...prevValues, [name]: value}));

    setError(Validation(contratEC, {...values, [name]: value}));
  };
  const backToMonEspace = () => {
    setShowErrorModal(false);
    navigate('MonEspace');
  };

  useFocusEffect(
    React.useCallback(() => {
      setValues({
        montant:
          contratEC.typeContrat === undefined &&
          contratEC.typePayment !== 'prime' &&
          contratEC.typePayment !== 'renouvellement'
            ? 0
            : contratEC.typeContrat === 'retraite'
            ? premierVersement
            : primTTC,
        motif: '',
        typeContrat: 'retraite',
        simulationId: contratEC.simulationId,
        numeroPolice: contratEC.numeroPolice,
        dateEffet:
          contratEC.typePayment === 'souscription'
            ? contratEC.dateEffet
            : nextDay.toISOString() || '',
      });
    }, [contratEC]),
  );

  return (
    <View style={{backgroundColor: 'white'}}>
      <HeaderScreen
        title="Paiement carte bancaire"
        type="retour"
        noBreadcrumb={false}
      />
      <LoaderWithMessage
        isModal
        isLoading={IsLoading}
        message={loaderMessage}
      />
      <PageContainer>
        {!IsLoading && (
          <View>
            <View>
              <Label
                title="Afin de sécuriser votre transaction, votre carte bancaire doit être enrôlé 3D secure pour effectuer ce paiement"
                type="mainTitle"
              />

              <InputField
                label={
                  contratEC.typeContrat === undefined &&
                  contratEC.typePayment === 'cotisation'
                    ? `Montant (minimum : ${MIN_COTISATION} Ar)`
                    : 'Montant (Ar)'
                }
                required
                value={
                  values.montant === 0 ? '' : separateurMillier(values.montant)
                }
                name="montant"
                type="price"
                onChange={handleChange}
                error={error.montant}
                showError={showErrors.montant}
                isEditable={
                  contratEC.typePayment === 'cotisation' ||
                  contratEC.typeContrat === 'retraite' ||
                  !!config.montantEditable
                }
                // isEditable
              />
              {contratEC.typeContrat != 'rcvp' &&
              contratEC.typeContrat != 'scolaire' &&
              contratEC.typeContrat != 'rattache' &&
              (contratEC.typePayment === 'prime' ||
                contratEC.typePayment === 'renouvellement') ? (
                <InputDatePicker
                  label={"Date d'effet"}
                  required
                  value={values?.dateEffet}
                  name="dateEffet"
                  onChange={handleChange}
                  dateMin={getNextDay(
                    new Date(handleDateValue(contratEC.dateEcheance)),
                  )}
                  isEditable={!(contratEC.typePayment != 'rapatriement')}
                />
              ) : null}
              <InputField
                label="Motif"
                required
                value={values.motif}
                name="motif"
                onChange={handleChange}
                error={error.motif}
                showError={showErrors.motif}
                maxLength={20}
              />
            </View>
            <View>
              <SubmitButtons
                cancelAction={handleCancel}
                submitAction={handleSubmit}
                cancelTitle="Annuler"
                submitTitle="Valider"
              />
            </View>
          </View>
        )}

        {/** Error modal */}
        {showInfoModal && (
          <ConfirmationModal
            title="Information"
            content={infoMessage}
            btn1="OK"
            handleBtn1={infoOkCompletion}
          />
        )}
        {showErrorModal && (
          <ConfirmationModal
            title="Erreur"
            content={errorMessage}
            btn1="OK"
            handleBtn1={backToMonEspace}
          />
        )}
      </PageContainer>
    </View>
  );
};

export const CbPayment: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CbPaymentForm);
